import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'submit'];

  update() {
    this.submitTarget.disabled = !this.checkboxTargets.every((checkbox) => checkbox.checked);
  }
}
